import { gql } from '@apollo/client';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardSection,
  CardSectionControl,
  CardSectionDescription,
  CardSectionTitle,
  CardTitle,
  Group,
} from '@apollo/orbit';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { LazyUrlModal } from 'src/components/common/LazyUrlModal';
import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { PermissionWarning } from 'src/components/permissionGuards/permissionWarning/PermissionWarning';
import { Config } from 'src/lib/config/config';
import { GraphQLTypes } from 'src/lib/graphqlTypes';
import { setOverlayVisibleLocation } from 'src/lib/routing';

import { DescriptionTemplateModal } from './DescriptionTemplateModal';

export const ProposalDescriptionTemplateCardFragment = gql`
  fragment ProposalDescriptionTemplateCardFragment on Service {
    id
    proposalDescriptionTemplate
  }
`;

export const ProposalDescriptionTemplateCard = ({
  graph,
}: {
  graph: GraphQLTypes.ProposalDescriptionTemplateCardFragment;
}) => {
  const location = useLocation();
  return (
    <>
      <Card>
        <CardHeader>
          <CardTitle>Proposal description template</CardTitle>
        </CardHeader>
        <CardBody>
          <CardSection className="flex-row">
            <Group orientation="vertical">
              <CardSectionTitle>Description template</CardSectionTitle>
              <CardSectionDescription>
                Create or edit a template for proposal descriptions. The
                template prepopulates the description of all newly created
                proposals for this graph.
              </CardSectionDescription>
            </Group>
            <CardSectionControl>
              <PermissionWarning
                graphId={graph.id}
                graphPermissions="canManageProposalPermissions"
                childRenderer={(hasPermission) => (
                  <Tooltip
                    label="You need permissions to manage proposals to set a description template"
                    disabled={hasPermission}
                    placement="top"
                  >
                    <Button
                      variant="secondary"
                      className="mt-4 w-fit md:mt-0"
                      isDisabled={!hasPermission}
                      as={Link}
                      to={setOverlayVisibleLocation({
                        location,
                        overlayName:
                          Config.modals.setProposalDescriptionTemplate,
                      })}
                    >
                      Update template
                    </Button>
                  </Tooltip>
                )}
              />
            </CardSectionControl>
          </CardSection>
        </CardBody>
      </Card>
      <LazyUrlModal name={Config.modals.setProposalDescriptionTemplate}>
        {({ closeModal, isOpen }) => (
          <DescriptionTemplateModal
            isOpen={isOpen}
            onClose={closeModal}
            graph={graph}
          />
        )}
      </LazyUrlModal>
    </>
  );
};
